import { Deserializable } from '../deserializable';

export class TransactionSearchRequest implements Deserializable {

    public searchTerm: string;
    public searchBy: string = "Full Name";
    public page: number = 1;
    public rows: number = 40;
    public orderBy: string;
    public orderDirection: string;
    public transactionStatusId: number = 0;
    public arbFacilitatorId: number;
    public brokerId: number
    public userId:number;
    public includeDocuments:boolean = true;
    public dateFilter: number = 5; //5=all

    deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }
}
